import ReviewSkill from './ReviewSkill'
export default ReviewSkill
